import React from "react";
import Image from "next/image";
import styles from "../../styles/shap_of_you.module.scss";
import shapofyoulogo from "../../assets/images/SENCO-SHAPE-OF-YOU-FULL_2.gif";
import sencoLogo from "../../assets/images/senco-shap-scree.png";
import { DesktopNavigationProps } from "./types";

const SplashScreen: React.FC<DesktopNavigationProps> = () => {
  return (
    <div className="d-none d-md-block w-100">
      <div className={styles.desktop_view_shap}>
        <div className={styles.shapeOfYou}>
          <div className={styles.content}>
            <div className={styles.title}>
              <Image src={shapofyoulogo} alt="Shape of You Logo" />
            </div>
            <div className={styles.byLine}>
              <Image
                src={sencoLogo}
                alt="Senco Gold & Diamonds"
                className={styles.logo}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
